export default function SnpImpactSymbol({ symbol, fill, size = 8 }) {
  if (symbol !== "up-triangle" && symbol !== "down-triangle") {
    return null;
  }

  const points = symbol === "up-triangle" ? "4,0 8,8 0,8" : "4,8 8,0 0,0";

  return (
    <svg width={size} height={size} viewBox="0 0 8 8" fill="none" aria-hidden="true">
      <polygon points={points} fill={fill} />
    </svg>
  );
}
